import { useRef } from 'react';
import { useOutletContext } from 'react-router-dom';

import Introduction from './Introduction/Introduction';

import './monitor.css';

const TABLET_IDS = [1, 2];
const QUESTION_IDS = ['question1', 'question2', 'question3', 'question4', 'question5'];

const questionModules = import.meta.glob('./Question*/Question*.jsx', {
  eager: true,
  import: 'default',
});

const questionComponents = Object.entries(questionModules).reduce(
  (components, [modulePath, Question]) => {
    const match = modulePath.match(/\.\/Question([1-5])\/Question\1\.jsx$/);

    if (!match) return components;

    return {
      ...components,
      [`question${match[1]}`]: Question,
    };
  },
  {},
);

function MonitorPanel({ questionId, lastAnswer, tabletLang }) {
  const mapContainerRef = useRef(null);
  const TabletQuestion = questionComponents[questionId];

  if (!TabletQuestion) return null;

  return (
    <section className="monitor__panel">
      <div ref={mapContainerRef} className="monitor__map-container" />
      <TabletQuestion
        key={questionId}
        lastAnswer={lastAnswer}
        mapContainerRef={mapContainerRef}
        fitOnResize
        tabletLang={tabletLang}
      />
    </section>
  );
}

function Monitor() {
  const { tabletRoutes, tabletLanguages, lastAnswers } = useOutletContext();
  const activeTabletIds = TABLET_IDS.filter(tabletId => (
    QUESTION_IDS.includes(tabletRoutes[tabletId])
  ));

  if (!activeTabletIds.length) return <Introduction />;

  return (
    <main
      className="monitor"
      style={{ '--monitor-panel-count': activeTabletIds.length }}
    >
      {activeTabletIds.map(tabletId => (
        <MonitorPanel
          key={tabletId}
          questionId={tabletRoutes[tabletId]}
          lastAnswer={lastAnswers[tabletId]}
          tabletLang={lastAnswers[tabletId]?.lang || tabletLanguages[tabletId] || 'nl'}
        />
      ))}
    </main>
  );
}

export default Monitor;
